import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {NcSharedModule} from 'nc-shared';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {NcQuickSearchComponent} from './nc-quick-search/nc-quick-search.component';

@NgModule({
  declarations: [NcQuickSearchComponent],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatOptionModule,
    NcSharedModule,
    ScrollingModule,
    MatButtonModule,
    TranslateModule,
    MatProgressBarModule
  ],
  exports: [NcQuickSearchComponent]
})
export class NcQuickSearchModule { }
